export default function Footer() {
return(<>
<footer className="backdrop-blur" style={{backgroundColor:'#6060602e'}}>
            <div className="container mx-auto">
              <p className="py-4 text-center text-white">
                © ArtChainAuction 2023
              </p>
            </div>
          </footer>
</>)    
}